import { inject, Injectable, signal } from '@angular/core';
import {
  BehaviorSubject,
  combineLatestWith,
  map,
  Observable,
  of,
  tap,
} from 'rxjs';
import { DeviceService } from '@gains-com/ui-angular';
import { Platform } from '../core/platform.service.js';

@Injectable({
  providedIn: 'root',
})
export class ShellService {
  private readonly _deviceService = inject(DeviceService);
  private readonly _platform = inject(Platform);

  rightSidenavIsOpen$ = new BehaviorSubject(false);

  private _leftSidenavIsOpen$ = new BehaviorSubject(false);

  /** Whether the left sidenav is collapsed (icon-only mode). Only applies to non-mobile views. */
  leftSidenavCollapsed = signal(false);

  leftSidenavIsOpen$: Observable<boolean> = this._platform.isServer
    ? of(
        !this._deviceService.isMobilePlatform &&
          this._deviceService.deviceKnownOrIsBrowser
      )
    : this._deviceService.gtSmScreen$.pipe(
        tap((gtSm) => {
          if (!gtSm && this._leftSidenavIsOpen$.value) {
            this.toggleLeftSidenav();
          }
        }),
        combineLatestWith(this._leftSidenavIsOpen$),
        map(([gtSm, leftSidenavOpen]) => gtSm || leftSidenavOpen)
      );

  rightSidenavFriendsTabSelected$ = new BehaviorSubject(false);
  rightSidenavChatTabSelected$ = new BehaviorSubject(false);

  closeSidenavs() {
    this._leftSidenavIsOpen$.next(false);
    this.rightSidenavIsOpen$.next(false);
  }

  toggleLeftSidenav() {
    if (this.rightSidenavIsOpen$.value) {
      this.toggleRightSidenav();
    }

    this._leftSidenavIsOpen$.next(!this._leftSidenavIsOpen$.value);
  }

  toggleRightSidenav() {
    if (this._leftSidenavIsOpen$.value) {
      this.toggleLeftSidenav();
    }

    this.rightSidenavIsOpen$.next(!this.rightSidenavIsOpen$.value);
  }

  /** Toggle the collapsed state of the left sidenav (icon-only mode). */
  toggleLeftSidenavCollapsed() {
    this.leftSidenavCollapsed.update((collapsed) => !collapsed);
  }
}
